import { checkSingleEmail, DebounceResult } from './api'

type ValidEmailCheck = {
  result: DebounceResult
  isValid: boolean
}

export class DebounceService {
  static verifyEmail = async (email: string): Promise<ValidEmailCheck> => {
    const apiResult = await checkSingleEmail(email)
    switch (apiResult.debounce?.result) {
      case 'Safe to Send':
        return { isValid: true, result: apiResult }
      default:
        return { isValid: false, result: apiResult }
    }
  }
}
